import { API } from "aws-amplify";
import { listBiests } from "../graphql/queries";

export default async function fetchBiestListFarmer(setData, farmer) {
    let allBiests = [];
    let nextToken = null;

    try {
        do {
            const response = await API.graphql({
                query: listBiests,
                variables: {
                    limit: 100000,
                    nextToken: nextToken,
                    filter: {
                        boerEmail: {
                            eq: farmer
                        }
                    }
                }
            });

            const { items, nextToken: newToken } = response.data.listBiests;
            allBiests = [...allBiests, ...items];
            nextToken = newToken;
        } while (nextToken);

        setData(allBiests);
    } catch (error) {
        console.error("Error fetching farmer-specific Biests:", error);
    }
}
